/**
 * Matemática financeira única do sistema (sem dependências: roda no site, no painel e na API).
 * Toda parcela pela Tabela Price — simulador do site, crediário, financiamento e portas mock —
 * passa por aqui, para o cliente nunca ver dois valores diferentes para a mesma conta.
 */

/** Fator Price: parcela = principal × fator. `i` é a taxa decimal ao mês (0,0189 = 1,89%). */
export function fatorPrice(i: number, n: number): number {
  if (n <= 0) throw new RangeError('Prazo precisa ser maior que zero');
  if (i === 0) return 1 / n;
  return i / (1 - (1 + i) ** -n);
}

/** Parcela Price em centavos (arredondada ao centavo). */
export function parcelaPriceCentavos(principalCentavos: number, i: number, n: number): number {
  if (principalCentavos <= 0) return 0;
  return Math.round(principalCentavos * fatorPrice(i, n));
}
